module.exports = "/images/pergamum.svg?1daf403cc266cae7d6de9032ee67b268";